import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl-next';

import { Box, xcss } from '@atlaskit/primitives';
import ErrorIcon from '@atlaskit/icon/core/error';
import { token } from '@atlaskit/tokens';

import { sharedI18n } from './analyticsShared18n';

const inlineTextStyles = xcss({
	display: 'inline',
});

// Use this component with a <Flex/> container to adjust the placement of the inner elements
export const AnalyticsCommonErrorState = () => {
	const { formatMessage } = useIntl();

	return (
		<>
			<ErrorIcon
				spacing="spacious"
				label={formatMessage(sharedI18n.serverErrorMessageTitle)}
				color={token('color.icon.warning')}
			/>
			<Box xcss={inlineTextStyles}>
				<FormattedMessage {...sharedI18n.serverErrorMessageTitle} />{' '}
				<FormattedMessage {...sharedI18n.serverErrorMessageDescription} />
			</Box>
		</>
	);
};
